import { moduleRouteDictionaryFactory } from '@tundr/routing';
import { depositRoutesDictionary } from '@modules/app/deposit/routes/deposit-routes.dictionary.ts';
import {
  employeeRoutesDictionary,
  subscriptionRoutesDictionary,
} from '@modules/app/employee/routes/employee-routes.dictionary.ts';
import { hrRoutesDictionary } from '@modules/app/hr/routes/hr-routes.dictionary.ts';
import { mealVouchersRoutesDictionary } from '@modules/app/meal-vouchers/routes/meal-vouchers-routes.dictionary.ts';
import { officeRoutesDictionary } from '@modules/app/office/routes/office-routes.dictionary.ts';
import { tracciatoBustaPagaReportsRoutesDictionary } from '@modules/app/reports/routes/TracciatoBustaPaga/tracciato-busta-paga-reports-routes.dictionary.ts';
import { voucherReportsRoutesDictionary } from '@modules/app/reports/routes/Voucher/voucher-reports-routes.dictionary.ts';
import { authRoutesDictionary } from '@modules/auth/routes/auth-routes.dictionary.ts';
import { cardRoutesDictionary } from './../../modules/app/card/routes/card-routes.dictionary';
import { creditsRoutesDictionary } from './../../modules/app/credits/routes/credits-routes.dictionary';
import { flexCreditsRoutesDictionary } from './../../modules/app/flex-credits/routes/flex-credits-routes.dictionary';
import { fringeThresholdsRoutesDictionary } from './../../modules/app/fringe-thresholds/routes/fringe-thresholds-routes.dictionary';
import { dashboardRoutesDictionary } from '@modules/app/dashboard/routes/dashboard-routes.dictionary.ts';

const rootRoutesDictionary = moduleRouteDictionaryFactory('root', '/', {
  notFound: '/:pathMatch(.*)*',
  app: '/app',
  forbidden: '/app/forbidden',
});

export const appRoutesDictionary = {
  ...rootRoutesDictionary,
  ...authRoutesDictionary,
  ...hrRoutesDictionary,
  ...creditsRoutesDictionary,
  ...flexCreditsRoutesDictionary,
  ...mealVouchersRoutesDictionary,
  ...employeeRoutesDictionary,
  ...subscriptionRoutesDictionary,
  ...officeRoutesDictionary,
  ...cardRoutesDictionary,
  ...fringeThresholdsRoutesDictionary,
  ...voucherReportsRoutesDictionary,
  ...tracciatoBustaPagaReportsRoutesDictionary,
  ...depositRoutesDictionary,
  ...dashboardRoutesDictionary,
};
